export const drawTableOptions = {
  width: 'auto',
  height: '500',
  colors: [
    '#fe5e54',
    '#37008e',
    '#00c9b7',
    '#fcd300',
  ],
  legend: {
    position: 'top',
    maxLines: 5,
    alignment: 'center',
    height: '10',
  },
  hAxis: {
    slantedText: true,
    slantedTextAngle: 45,
    maxAlternation: 3,
    showTextEvery: 1,
  },
  chartArea: {
    top: '10%',
    left: '55',
    width: '100%',
    height: '70%',
  },
  pointSize: 5,
  pointsVisible: true,

  vAxis: {
    format: '#,###',
  },
};
